<template>
  <div class="shop-finally shop-main" v-if="currentPagePayment.type">
    <span
      class="shop-main__card active"
      :style="{
        background: `url(${currentDesing.image}) no-repeat center / cover`,
      }"
    >
      <span>{{
        currentLoyalityKind === "certificate" ? "Сертификат" : "Абонемент"
      }}</span>
    </span>
    <div class="shop-form">
      <div class="phase">
        <div class="phasetop">
          <span class="phasename">{{
            paymentStatus === "success"
              ? "Успешно оформлен и оплачен"
              : "Не оплачен"
          }}</span>
        </div>
        <div class="load">
          <div
            style="width: 100%"
            :style="{
              'background-color':
                paymentStatus === 'success' ? '#6CA475' : '#E4C09E',
            }"
          ></div>
        </div>
      </div>

      <div v-if="paymentStatus === 'failed'" class="shop-form__block _failed-payment" >
        <h2>К сожалению, оплата не прошла</h2>
        <div class="text">Заказ не был успешно завершен. Пожалуйста, попробуйте снова.</div>
        <div :class="
        store.state.isPaymentLoader ? '_loader _loader-40px ' : ''
      ">
          <a class="button next" @click="store.dispatch('rePayment')">Оплатить</a>
        </div>
        
      </div>

      <div class="shop-form__block">
        <div class="text3">{{ titleText }}</div>
        <div class="text2">{{ currentPagePayment.Data.Name }}</div>
        <div class="text2">{{ currentPagePayment.Data.Phone }}</div>
        <div class="text2">{{ currentPagePayment.Data.Email }}</div>
      </div>

      <div class="shop-form__block" v-if="isOther">
        <div class="text3">Покупатель:</div>
        <div class="text2">{{ currentPagePayment.Data.BuyerName }}</div>
        <div class="text2">{{ currentPagePayment.Data.BuyerEmail }}</div>
        <div class="text2">{{ currentPagePayment.Data.BuyerPhone }}</div>
      </div>

      <div class="expiration-date">
        <span class="time">{{titleStr}} <br>{{ currentBuyLoyality.expiration }}</span
        ><span class="price"
          >{{
            currentLoyalityKind === "certificate"
              ? currentBuyLoyality.type.balance.toLocaleString()
              : currentBuyLoyality.type.cost.toLocaleString()
          }}
          ₽</span
        >
      </div>

      <a
        class="button next"
        href="https://tekstura.moscow/"
        v-if="paymentStatus === 'success'"
        >Перейти на главную</a
      >
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";

const store = useStore();

const route = useRoute();
const paymentStatus = computed(() => route.query.pay);

const loyalityTypes = computed(() => store.state.allLoyalityTypes);

const isOther = computed(() => !!currentPagePayment.value.Data.BuyerPhone);
const isSentToSelf = computed(() => currentPagePayment.value.Data.SendTo === 'self');

const currentPagePayment = computed(() => store.state.currentPagePayment);

const currentDesing = computed(() => store.state.allDesignTypes.find(i => i.id === currentPagePayment.value.design_id))

const currentLoyalityKind = computed(() => currentPagePayment.value.type);

const currentBuyLoyality = computed(() => {
  const currentBuy = [
    ...loyalityTypes.value.certificates,
    ...loyalityTypes.value.abonements,
  ].find((i) => i.id === currentPagePayment.value.currentLoyality.id);

  const expiration =
    currentPagePayment.value.type === "certificate"
      ? getExpirationStringForCertificate(currentBuy)
      : getExpirationStringForAbonement(currentBuy);

  return {
    type: currentBuy,
    expiration: expiration,
  };
});

const titleStr = computed(() => {
  return currentBuyLoyality.value.type.title.replace(/\//g, '|');
})

const titleText = computed(() => {
  const text1 = "Отправлен на вашу почту";
  const text2 = "Отправлен вам для самостоятельного вручения";
  const text3 = "Отправлен будущему владельцу";
  const text4 = "Будет отправлен на вашу почту после успешной оплаты";
  const text5 =
    "Будет отправлен вам для самостоятельного вручения после успешной оплаты";
  const text6 = "Будет отправлен будущему владельцу после успешной оплаты";

  const status = paymentStatus.value;

  if (status === "success") {
    if (isOther.value) {
      if (isSentToSelf.value) {
        return text2;
      } else {
        return text3;
      }
    } else {
      return text1;
    }
  } else {
    if (isOther.value) {
      if (isSentToSelf.value) {
        return text5;
      } else {
        return text6;
      }
    } else {
      return text4;
    }
  }
});
</script>

<style lang="scss" scoped>
.shop-form__block {
  display: block;

  &._failed-payment {
    border-color:#E4C09E ;
  }
}
h2 {
  margin-bottom: 15px;
}
.mb-10px {
  margin-bottom: 10px;
}

.shop-main__card.active {
  cursor: default;
}

.expiration-date {
  margin-top: 16px;
  margin-bottom: 16px;
}
.shop-finally {
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
